export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              联系投稿
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              欢迎漫画作者、版权方与我们合作，让更多读者发现你的作品
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            <div className="group p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/70 text-center hover:border-primary-200 transition-all duration-300 cursor-pointer">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mx-auto mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className="ri-mail-send-line text-2xl"></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">作品投稿</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                如果你是一名漫画创作者，欢迎将作品投稿至布丁漫画，我们将为优质作品提供专属推广资源。
              </p>
              <span className="inline-block mt-4 text-sm text-primary-500 font-medium whitespace-nowrap">
                contact@puddingcomic.com
              </span>
            </div>

            <div className="group p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/70 text-center hover:border-primary-200 transition-all duration-300 cursor-pointer">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 mx-auto mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                <i className="ri-group-line text-2xl"></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">商务合作</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                版权合作、广告投放、品牌联动等商务需求，欢迎随时联系我们洽谈合作方案。
              </p>
              <span className="inline-block mt-4 text-sm text-primary-500 font-medium whitespace-nowrap">
                biz@puddingcomic.com
              </span>
            </div>

            <div className="group p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/70 text-center hover:border-primary-200 transition-all duration-300 cursor-pointer">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 mx-auto mb-4 group-hover:bg-secondary-500 group-hover:text-background-50 transition-all duration-300">
                <i className="ri-question-answer-line text-2xl"></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">用户反馈</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                在使用布丁漫画下拉式阅读过程中遇到任何问题或有功能建议，欢迎向我们反馈。
              </p>
              <span className="inline-block mt-4 text-sm text-primary-500 font-medium whitespace-nowrap">
                feedback@puddingcomic.com
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}